<template lang="pug">
.sv-tabs
    .sv-tabs__header
        .sv-tabs__list
            .sv-tabs__tab(
                v-for="(tab, index) in tabs"
                :key="index"
                :class="{ 'sv-tabs__tab--active': index === value }"
                @click="changeTab(index)"
            )
                | {{ tab }}

        .sv-tabs__actions
            slot
</template>

<script>
export default {
  name: 'SvTabs',

  props: {
    value: {
      type: Number,
      default: 0,
    },

    tabs: {
      type: Array,
      required: true,
    },
  },

  methods: {
    changeTab(index) {
      this.$emit('input', index);
    },
  },
};
</script>

<style lang="scss" scoped>
.sv-tabs {
    &__header {
        display: flex;
        justify-content: space-between;
        padding: 0 15px;
        background-color: #F8F8FA;
        border-radius: 15px 15px 0px 0px;
    }

    &__list {
        display: flex;
    }

    &__tab {
        display: flex;
        align-items: center;
        height: 70px;
        padding: 0 15px;
        position: relative;
        cursor: pointer;
        text-transform: uppercase;
        font-size: 14px;
        font-weight: 500;
        color: #ADB2C0;

        &:hover {
            color: #0882DB;
        }

        &--active {
            color: #404450;
        }

        &--active:after {
            content: '';
            height: 3px;
            width: 100%;
            position: absolute;
            left: 0;
            bottom: 0;
            background-color: #1993EB;
        }
    }
}
</style>
